import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import MultiCustomCreatableSelection from "@components/Common/MultiCustomCreatableSelection";
import FormField from "../FormField";

interface Props {
    tagsData: any[];
    tags: any[];
    isConsult: boolean;
    isSendingTag: boolean;
    setResult: (val: any) => void;
    onDelete: () => void;
    onChange: () => void;
}

const TagsField = React.memo(
    ({
        tagsData,
        tags,
        isConsult,
        isSendingTag,
        setResult,
        onDelete,
        onChange,
    }: Props) => {
        const { t } = useTranslation();

        const formatCreateLabel = useCallback(
            (inputValue: any) => (
                <span>
                    {inputValue} ({t("New tag")})
                </span>
            ),
            [t]
        );

        const noOptionsMessage = useCallback(() => t("No options"), [t]);

        return (
            <FormField label={t("Tag")} disabled={isConsult}>
                <MultiCustomCreatableSelection
                    isSendingTag={isSendingTag}
                    onDelete={onDelete}
                    setResult={setResult}
                    result={tagsData}
                    data={tags}
                    onChange={onChange}
                    className="mdi_inp_FRtags"
                    placeholder={`${t("Select")}…`}
                    value=""
                    name="tag"
                    noOptionsMessage={noOptionsMessage}
                    formatCreateLabel={formatCreateLabel}
                />
            </FormField>
        );
    }
);

TagsField.displayName = "TagsField";
export default TagsField;
